import { combineReducers } from 'redux';
import { reducer as base } from './base';
import { reducer as dimensionData } from './dimensionData';
import { reducer as benchmarkData } from './benchmark';
import { reducer as metricData } from './metricsData';
import { reducer as kpiData } from './kpiData';
import { reducer as widgetMessageData } from './widgetMessageData';
import { reducer as audienceMetricData } from './audienceMetrics';
import { reducer as spiThresholds } from './spiThresholds';
import { reducer as sharing } from './sharing';
import { reducer as dashboard } from './dashboard';
import { reducer as tempDashboard } from './tempDashboard';
import { reducer as impactedViewers } from './impactedViewers';

export default combineReducers({
  base,
  dimensionData,
  benchmarkData,
  metricData,
  kpiData,
  widgetMessageData,
  audienceMetricData,
  spiThresholds,
  sharing,
  dashboard,
  tempDashboard,
  impactedViewers,
});
